import { render, staticRenderFns } from "./ShiftAtom.vue?vue&type=template&id=8f018996&"
import script from "./ShiftAtom.vue?vue&type=script&lang=ts&"
export * from "./ShiftAtom.vue?vue&type=script&lang=ts&"
import style0 from "./ShiftAtom.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports